export default __webpack_public_path__ + "static/media/copy-icon.8257f1b6.svg";